import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import payment from "../../services/payment";
import { Box, Container, ContainerActions, ContainerContent, ContainerHeader, Field } from "./styles";
import Loading from "../Loading";

const useQuery = () => {
    const { search } = useLocation();
    return React.useMemo(() => new URLSearchParams(search), [search]);
}

const PaymentResult = () => {
    let query = useQuery();
    const checkoutSessionId = query.get("checkout_session_id");

    const [checkoutSessionData, setCheckoutSessionData] = useState({});
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        const loadData = async () => {
            const checkoutData = await payment.getCheckoutData(checkoutSessionId);
            console.log('checkoutData',checkoutData)
            if (checkoutData && checkoutData.data) setCheckoutSessionData(checkoutData.data);
        }
        setIsLoading(true);
        loadData();
        setIsLoading(false);
    }, []);

    return (
        <Container>
            {isLoading && <Loading />}
            <Box>
                <ContainerHeader>
                    {checkoutSessionData?.payment_status && checkoutSessionData?.status && 
                        checkoutSessionData?.payment_status === 'paid' && checkoutSessionData?.status === 'complete'
                            ? <h2>Tudo certo!</h2> 
                            : <h2>Processando</h2>}
                </ContainerHeader>
                <ContainerContent>
                    <Field>
                        <h3 className='field-title'>Nome:</h3>
                        <h3 className='field-value'>{checkoutSessionData?.customer_details?.name}</h3>
                    </Field>
                    <Field>
                        <h3 className='field-title'>Email:</h3>
                        <h3 className='field-value'>{checkoutSessionData?.customer_details?.email}</h3>
                    </Field>
                    <Field>
                        <h3 className='field-title'>Valor:</h3>
                        <h3 className='field-value'>
                            {checkoutSessionData?.amount_total 
                                ? 'R$ ' + (checkoutSessionData?.amount_total / 100).toLocaleString('pt-BR', {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2
                                }) 
                                : ' - '}
                        </h3>
                    </Field>
                    <Field>
                        <h3 className='field-title'>Status:</h3>
                        <h3 className='field-value'>{checkoutSessionData?.payment_status} - {checkoutSessionData?.status}</h3>
                    </Field>
                </ContainerContent>
                <ContainerActions>
                    {/* <Button
                        size='nano'
                        color='green'
                        format='solid'
                        width='100%'
                        onClick={handleSubscribe}
                    >Seguir Para Pagamento</Button> */}
                </ContainerActions>
            </Box>
        </Container>
    )
}

export default PaymentResult;